import HttpFactory from '../factory'
import { AssigneeTypeEnum, type CreateDeviceAssignment, type DeviceAssignment } from '../types/device-assignment'

class DeviceAssignmentsModule extends HttpFactory<any[]> {
  private RESOURCE = '/device-assignments'

  async getByPatientId(patientId: string) {
    let arr: DeviceAssignment[] = []
    let nextPageUrl = `?assigneeId=${patientId}&assigneeType=${AssigneeTypeEnum.patient}`
    do {
      await this.call<any>('GET', `${this.RESOURCE}${nextPageUrl}`).then((response) => {
        arr = arr.concat(response.items)
        nextPageUrl = response.nextPageUrl
      })
    } while (nextPageUrl)
    return arr
  }
  async getActiveByPatientIdWithLimit(patientId: string, limit: number, abortSignal?: AbortSignal | undefined) {
    let arr: DeviceAssignment[] = []
    let nextPageUrl = `?assigneeId=${patientId}&assigneeType=${AssigneeTypeEnum.patient}&pageSize=${limit}&assigned=true`
    await this.call<any>('GET', `${this.RESOURCE}${nextPageUrl}`, undefined, undefined, abortSignal).then((response) => {
      arr = arr.concat(response.items)
      nextPageUrl = response.nextPageUrl
    })
    return arr
  }

  async getByPatientIdWithLimit(patientId: string, limit: number, abortSignal?: AbortSignal | undefined) {
    let arr: DeviceAssignment[] = []
    let nextPageUrl = `?assigneeId=${patientId}&assigneeType=${AssigneeTypeEnum.patient}&pageSize=${limit}`
    await this.call<any>('GET', `${this.RESOURCE}${nextPageUrl}`, undefined, undefined, abortSignal).then((response) => {
      arr = arr.concat(response.items)
      nextPageUrl = response.nextPageUrl
    })
    return arr
  }

  async getByDeviceId(deviceId: string) {
    let arr: DeviceAssignment[] = []
    let nextPageUrl = `?deviceId=${deviceId}`
    do {
      await this.call<any>('GET', `${this.RESOURCE}${nextPageUrl}`).then((response) => {
        arr = arr.concat(response.items)
        nextPageUrl = response.nextPageUrl
      })
    } while (nextPageUrl)
    return arr
  }

  async getAssignedByMe() {
    let arr: DeviceAssignment[] = []
    let nextPageUrl = `?assignedByMe=true&assigned=true`
    do {
      await this.call<any>('GET', `${this.RESOURCE}${nextPageUrl}`).then((response) => {
        arr = arr.concat(response.items)
        nextPageUrl = response.nextPageUrl
      })
    } while (nextPageUrl)
    return arr
  }

  async createAssignment(assignment: CreateDeviceAssignment) {
    return await this.call<any>('POST', `${this.RESOURCE}`, assignment)
  }
  // /device-assignments/{{device-assignment_id}}/authentication-requests

  async authenticateAssignment(assignmentId: string, token: any) {
    return await this.call<any>('POST', `${this.RESOURCE}/${assignmentId}/authentication-requests`, token)
  }

  async deleteAssignment(assignment: any) {
    return await this.call<any>('PATCH', `${this.RESOURCE}/${assignment.id}?revision=${assignment.revision}`, {
      endedAt: new Date().toISOString(),
    })
  }

  async extendAssignment(assignment: any) {
    return await this.call<any>('PATCH', `${this.RESOURCE}/${assignment.id}?revision=${assignment.revision}`, {
      expiresAt: assignment.expiresAt,
      endedAt: null,
    })
  }
}

export default DeviceAssignmentsModule
